module.exports = __webpack_public_path__ + "img/587.40c8ae0f.png";